import { Environment } from '@atlassiansox/bxpkit-core';

type nextUrlOptions = {
  accountName: string | null;
  product?: string;
  bundle?: string;
  edition?: string;
  signupSource?: string;
  hideUserSegmentation?: string;
  templateId?: string;
  platform?: string;
  team_type?: string;
};

// Returns a url to redirect the user to after submitting the form
export const nextUrl = (options: nextUrlOptions) => (url: string) => {
  let href;

  const splitPath = url.split('/');

  if (url.startsWith('http')) {
    href = new URL(url);
  } else if (url[1]?.includes('wac')) {
    splitPath.splice(0, 2);
    href = new URL(
      `${Environment.getWacIntegrationUrl()}/${splitPath.join('/')}`
    );
  } else {
    href = new URL(window.location.href);
    href.pathname = url;
  }
  const params = href.searchParams;

  Object.entries(options)
    .filter(([_key, value]) => value)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .forEach(([key, value]) => params.set(key, value!));

  href.search = params.toString();

  return href.toString();
};
